//  FILE:  src/actions/agency.js
// this file is part of orginal BSG system
/* globals fetch, localStorage */
import Globals from '../utils/globals' // xt import the global values like a config setup
import { logException } from '../utils/AppLogger' // xt looks like it displays error on console...??
import {getRequestOptions } from '../utils/ApiHelper' // grabs token from local storage, sets req to GET
import { setError } from './findError' // xt not sure what this is really doing. action calling action?

// 20241030 xt these might be the triggers but the real function called by the components is "fetchAgency"
// which uses these triggers"
export const REQUEST_AGENCY = 'REQUEST_AGENCY'
export const RECEIVE_AGENCY = 'RECEIVE_AGENCY'
export const REQUEST_AGENCY_FAILURE = 'REQUEST_AGENCY_FAILURE'

export const requestAgency = (id) => {
  return {
    type: REQUEST_AGENCY,
    agencyId: id
  }
}

export const receiveAgency = (json) => {
  console.log("[action] receiveAgency: json =", json); // ✅ debug log
  return {
    type: RECEIVE_AGENCY,
    details: json,
    receivedAt: Date.now()
  }
}

export const fetchAgencyFailure = (error) => {
  logException(error, {
    profile: localStorage.getItem('profile')
  })

  return {
    type: REQUEST_AGENCY_FAILURE,
    error
  }
}

export const fetchAgency = (id, token) => {
  return dispatch => {
    let res;

    if (!token) {
      console.error('agency.js - No token provided');
      return dispatch(setError(null, 'Token not found', 'No API token available. Please log in again.'));
    }

    const requestOptions = getRequestOptions(token);
    dispatch(requestAgency(id));

    return fetch(`${Globals.apiEndpoint}/dashboard/agencies/${id}`, requestOptions)
      .then(response => {
        res = response;
        return response.json();
      })
      .then(json => {
        if (res.status !== 200) {
          return dispatch(setError(res.status, res.statusText, json.message));
        } else {
          console.log("[in actions/agency: fetchAgency] dispatching receiveAgency with:", json); // ✅
          dispatch(receiveAgency(json));
        }
      })
      .catch(error => {
        dispatch(fetchAgencyFailure(error));
        dispatch(setError(null, 'Network Error', error.message));
      });
  };
};
